
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 14 8","fill":"#47AEA6","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.506 1.835c0-.376.141-.706.376-.988C1.447.188 2.388.141 3.047.706L7 4.188l3.953-3.53c.659-.564 1.6-.47 2.165.142.564.659.517 1.6-.142 2.165l-4.94 4.33a1.512 1.512 0 01-2.024 0l-4.988-4.33a1.503 1.503 0 01-.518-1.13z"}})])
          )
        }
      }
    